import { Component, Injector, OnInit } from '@angular/core';
import { UntypedFormArray, Validators } from '@angular/forms';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { CommandEnum } from '@app/forms/subscription/definition/interface/enum';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@UntilDestroy()
@Component({
    selector: 'credit-insurance-quotite',
    templateUrl: './credit-insurance-quotite.component.html',
    styleUrls: ['./credit-insurance-quotite.component.scss'],
    standalone: false
})
export class CreditInsuranceQuotiteComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    protected injector: Injector,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }
  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.setCommand([
      CommandEnum.GENERATE_BANKING_GUARANTEES_EQUIVALENTS,
    ]);
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }

  get insuranceQuotite(): UntypedFormArray {
    return this.form
      .get('products')
      .get('0')
      .get('parameters')
      .get('loan')
      .get('insuranceQuotite') as UntypedFormArray;
  }

  addInsuranceQuotite(): void {
    const group = this.formBuilder.group({
      ownerId: ['', Validators.required],
      quotite: [100, [Validators.required, Validators.max(100)]],
      assureLemoineDetails: [null, Validators.required],
    });
    this.insuranceQuotite.push(group);
  }

  removeInsuranceQuotite(index: number): void {
    this.insuranceQuotite.removeAt(index);
  }
}
